// import React, { useState, useEffect } from 'react';
// import { FiPlus, FiEye, FiGlobe } from 'react-icons/fi';
// import { announcementAPI, propertyAPI } from '../../services/api';
// import DataTable from '../../components/shared/DataTable';
// import Modal from '../../components/shared/Modal';

// const AnnouncementListPage = () => {
//   const [announcements, setAnnouncements] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showModal, setShowModal] = useState(false);
// const [showAlertModal, setShowAlertModal] = useState(false);  
// const [showCompare, setShowCompare] = useState(false);  
// const [compareList, setCompareList] = useState([]); // max 3 items  
// const [favorites, setFavorites] = useState(new Set());  
// const [viewMode, setViewMode] = useState('grid'); // 'grid' | 'list' | 'map'  
// const [tab, setTab] = useState('all'); // 'all' | 'favorites' | 'alerts'  
// const [filters, setFilters] = useState({  
//   q: '', type: '', city: '', transaction_type: '',  
//   min_price: '', max_price: '', min_surface: '', max_surface: '',  
//   rooms: '', is_featured: '',  
// });  
// const [showFilters, setShowFilters] = useState(false);  
// const [pagination, setPagination] = useState({ total: 0, offset: 0, limit: 20 });  
// const [alerts, setAlerts] = useState([]);  
// const [alertForm, setAlertForm] = useState({ name: '', criteria: {} });  
// const [properties, setProperties] = useState([]);  
// const [form, setForm] = useState({ property_id: '', title: '', description: '', seo_title: '', seo_description: '', is_featured: false, virtual_tour_url: '' });
//   const fetchAnnouncements = () => announcementAPI.list().then(r => { setAnnouncements(r.data); setLoading(false); }).catch(() => setLoading(false));
//   useEffect(() => { fetchAnnouncements(); }, []);

//   const openCreate = async () => {
//     try { const { data } = await propertyAPI.list({ limit: 100 }); setProperties(data.data || []); } catch (e) {}
//     setShowModal(true);
//   };

//   const handleCreate = async (e) => { e.preventDefault(); await announcementAPI.create(form); setShowModal(false); fetchAnnouncements(); };
//   const handlePublish = async (id, e) => { e.stopPropagation(); await announcementAPI.publish(id); fetchAnnouncements(); };

//   const columns = [
//     { header: 'Titre', accessor: 'title' },
//     { header: 'Bien', accessor: 'property_title' },
//     { header: 'Statut', render: (r) => <span className={`badge badge-${r.status === 'published' ? 'success' : 'secondary'}`}>{r.status === 'published' ? 'Publié' : 'Brouillon'}</span> },
//     { header: 'Vues', render: (r) => <><FiEye size={14} /> {r.views_count}</> },
//     { header: 'Vedette', render: (r) => r.is_featured ? <span className="badge badge-warning">Vedette</span> : '-' },
//     { header: 'Actions', render: (r) => r.status !== 'published' ? <button className="btn btn-success btn-sm" onClick={(e) => handlePublish(r.id, e)}><FiGlobe /> Publier</button> : null },
//   ];

//   return (
//     <div>
//       <div className="page-header">
//         <h1>Annonces</h1>
//         <button className="btn btn-primary" onClick={openCreate}><FiPlus /> Nouvelle annonce</button>
//       </div>
//       {loading ? <div className="loading"><div className="spinner" /></div> : (
//         <div className="card"><DataTable columns={columns} data={announcements} emptyMessage="Aucune annonce" /></div>
//       )}
//       <Modal isOpen={showModal} onClose={() => setShowModal(false)} title="Nouvelle annonce" size="lg">
//         <form onSubmit={handleCreate}>
//           <div className="form-group"><label>Bien *</label>
//             <select className="form-control" value={form.property_id} onChange={e => setForm({ ...form, property_id: e.target.value })} required>
//               <option value="">Sélectionner</option>
//               {properties.map(p => <option key={p.id} value={p.id}>{p.title}</option>)}
//             </select>
//           </div>
//           <div className="form-group"><label>Titre *</label><input className="form-control" value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} required /></div>
//           <div className="form-group"><label>Description</label><textarea className="form-control" value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} /></div>
//           <h3 style={{ margin: '16px 0 8px' }}>SEO</h3>
//           <div className="form-group"><label>Titre SEO</label><input className="form-control" value={form.seo_title} onChange={e => setForm({ ...form, seo_title: e.target.value })} /></div>
//           <div className="form-group"><label>Description SEO</label><textarea className="form-control" value={form.seo_description} onChange={e => setForm({ ...form, seo_description: e.target.value })} /></div>
//           <div className="form-group"><label><input type="checkbox" checked={form.is_featured} onChange={e => setForm({ ...form, is_featured: e.target.checked })} /> Annonce en vedette</label></div>
//           <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, marginTop: 16 }}>
//             <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Annuler</button>
//             <button type="submit" className="btn btn-primary">Créer</button>
//           </div>
//         </form>
//       </Modal>
//     </div>
//   );
// };

// export default AnnouncementListPage;

import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiPlus, FiEye, FiGlobe, FiSearch, FiFilter, FiGrid, FiList, FiTrash2, FiEdit3, FiBarChart2, FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { announcementAPI, propertyAPI, propertyUnitAPI } from '../../services/api';
import DataTable from '../../components/shared/DataTable';
import Modal from '../../components/shared/Modal';
import { toast } from 'react-hot-toast';

const AnnouncementListPage = () => {
  const navigate = useNavigate();
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [viewMode, setViewMode] = useState('grid');
  const [properties, setProperties] = useState([]);
  const [units, setUnits] = useState([]);
  const [loadingUnits, setLoadingUnits] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);
  
  const [filters, setFilters] = useState({
    q: '', status: '', transaction_type: '', city: '', is_featured: ''
  });
  
  const [pagination, setPagination] = useState({ total: 0, offset: 0, limit: 12 });

  const fetchAnnouncements = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await announcementAPI.list({
        ...filters,
        limit: pagination.limit,
        offset: pagination.offset
      });
      console.log('anouncementPage',data)
      setAnnouncements(data || []);
      setPagination(prev => ({ ...prev, total: data.total || 0 }));
    } catch (e) {
      toast.error('Erreur lors du chargement des annonces');
    } finally {
      setLoading(false);
    }
  }, [filters, pagination.offset, pagination.limit]);

  useEffect(() => { fetchAnnouncements(); }, [fetchAnnouncements]);

  const openCreate = async () => {
    try { 
      const { data } = await propertyAPI.list({ limit: 100, status: 'available' }); 
      setProperties(data.data || []); 
    } catch (e) { toast.error('Impossible de charger les biens'); }
    setShowModal(true);
  };

  const handleCreate = async (e) => { 
    e.preventDefault(); 
    try {
      await announcementAPI.create(form); 
      setShowModal(false); 
      fetchAnnouncements();
      toast.success('Annonce créée avec succès');
    } catch (e) {
      toast.error(e.response?.data?.error || 'Erreur de création');
    }
  };

  const handlePublish = async (id, e) => { 
    e.stopPropagation(); 
    try {
      await announcementAPI.publish(id); 
      fetchAnnouncements();
      toast.success('Annonce publiée');
    } catch (e) {
      toast.error('Erreur de publication');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer cette annonce ?')) return;
    try {
      await announcementAPI.delete(id);
      fetchAnnouncements();
      toast.success('Annonce supprimée');
    } catch (e) {
      toast.error('Erreur de suppression');
    }
  };

  const [form, setForm] = useState({ property_id: '', property_unit_id: '', title: '', description: '', seo_title: '', seo_description: '', is_featured: false, virtual_tour_url: '' });

  // Chargement des unités quand le bien change dans le modal création
  const handlePropertyChange = async (propertyId) => {
    const prop = properties.find(p => String(p.id) === String(propertyId));
    setSelectedProperty(prop || null);
    setForm(f => ({ ...f, property_id: propertyId, property_unit_id: '' }));
    setUnits([]);
    if (prop?.is_multi_unit && propertyId) {
      setLoadingUnits(true);
      try {
        const r = await propertyUnitAPI.listByProperty(propertyId);
        setUnits(r.data || []);
      } catch (e) {
        setUnits([]);
      } finally {
        setLoadingUnits(false);
      }
    }
  };

  const filteredCount = announcements.length;
  const totalPages = Math.ceil(pagination.total / pagination.limit);
  const currentPage = Math.floor(pagination.offset / pagination.limit) + 1;

  return (
    <div className="container">
      {/* Header */}
      <div className="page-header" style={{ flexWrap: 'wrap', gap: 12 }}>
        <h1>Annonces <span style={{ fontSize: 16, color: 'var(--text-secondary)', fontWeight: 400 }}>({pagination.total})</span></h1>
        <div style={{ display: 'flex', gap: 8, marginLeft: 'auto' }}>
          <button className={`btn btn-secondary btn-sm ${viewMode === 'list' ? 'active' : ''}`} onClick={() => setViewMode('list')}><FiList /></button>
          <button className={`btn btn-secondary btn-sm ${viewMode === 'grid' ? 'active' : ''}`} onClick={() => setViewMode('grid')}><FiGrid /></button>
          <button className="btn btn-secondary btn-sm" onClick={() => setShowFilters(!showFilters)}><FiFilter /> Filtres</button>
          <button className="btn btn-primary" onClick={openCreate}><FiPlus /> Nouvelle annonce</button>
        </div>
      </div>

      {/* Filtres */}
      {showFilters && (
        <div className="card" style={{ marginBottom: 16, animation: 'slideDown 0.2s ease' }}>
          <div className="card-body" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 12 }}>
            <div className="form-group" style={{ margin: 0 }}>
              <label>Recherche</label>
              <div style={{ position: 'relative' }}>
                <FiSearch style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: '#999' }} />
                <input className="form-control" style={{ paddingLeft: 36 }} placeholder="Titre, ville..." value={filters.q} onChange={e => setFilters({ ...filters, q: e.target.value })} />
              </div>
            </div>
            <div className="form-group" style={{ margin: 0 }}>
              <label>Statut</label>
              <select className="form-control" value={filters.status} onChange={e => setFilters({ ...filters, status: e.target.value, offset: 0 })}>
                <option value="">Tous</option>
                <option value="published">Publié</option>
                <option value="draft">Brouillon</option>
                <option value="archived">Archivé</option>
              </select>
            </div>
            <div className="form-group" style={{ margin: 0 }}>
              <label>Transaction</label>
              <select className="form-control" value={filters.transaction_type} onChange={e => setFilters({ ...filters, transaction_type: e.target.value, offset: 0 })}>
                <option value="">Tous</option>
                <option value="rent">Location</option>
                <option value="sale">Vente</option>
              </select>
            </div>
            <div className="form-group" style={{ margin: 0 }}>
              <label>Ville</label>
              <input className="form-control" placeholder="Bamako, Sikasso..." value={filters.city} onChange={e => setFilters({ ...filters, city: e.target.value, offset: 0 })} />
            </div>
            <div className="form-group" style={{ margin: 0, display: 'flex', alignItems: 'flex-end' }}>
              <button className="btn btn-primary" style={{ width: '100%' }} onClick={fetchAnnouncements}><FiSearch /> Appliquer</button>
            </div>
          </div>
        </div>
      )}

      {/* Grille / Liste */}
      {loading ? (
        <div style={{ display: 'grid', gridTemplateColumns: `repeat(auto-fill, minmax(${viewMode === 'grid' ? 280 : 400}px, 1fr))`, gap: 16 }}>
          {[1,2,3,4,5,6].map(i => <div key={i} className="skeleton-card" style={{ height: viewMode === 'grid' ? 320 : 120, background: '#f0f0f0', borderRadius: 12, animation: 'pulse 1.5s infinite' }} />)}
        </div>
      ) : announcements.length === 0 ? (
        <div className="card" style={{ textAlign: 'center', padding: 60 }}>
          <FiSearch size={48} style={{ color: 'var(--text-secondary)', marginBottom: 16 }} />
          <h3>Aucune annonce trouvée</h3>
          <p style={{ color: 'var(--text-secondary)' }}>Modifiez vos filtres ou créez une nouvelle annonce.</p>
        </div>
      ) : viewMode === 'grid' ? (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16 }}>
          {announcements.map(a => (
            <div key={a.id} className="card" style={{ overflow: 'hidden', cursor: 'pointer', transition: 'transform 0.2s, box-shadow 0.2s' }} onClick={() => navigate(`/announcements/${a.slug || a.id}`)}>
              <div style={{ height: 180, background: '#eee', position: 'relative', overflow: 'hidden' }}>
                {a.image_url ? <img src={a.image_url} alt={a.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#999' }}>Pas d'image</div>}
                {a.is_featured && <span className="badge badge-warning" style={{ position: 'absolute', top: 8, left: 8 }}>⭐ Vedette</span>}
                <span className={`badge badge-${a.status === 'published' ? 'success' : 'secondary'}`} style={{ position: 'absolute', top: 8, right: 8 }}>{a.status}</span>
              </div>
              <div style={{ padding: 16 }}>
                <h3 style={{ fontSize: 15, marginBottom: 8, fontWeight: 600 }}>{a.title}</h3>
                <div style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 8 }}>{a.property_title}{a.unit_number ? ` (Unité ${a.unit_number})` : ''} — {a.city}</div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontWeight: 700, color: 'var(--primary)' }}>{parseInt(a.price || 0).toLocaleString()} XOF</span>
                  <span style={{ fontSize: 12, color: '#999' }}><FiEye /> {a.views_count || 0}</span>
                </div>
                <div style={{ display: 'flex', gap: 6, marginTop: 12, paddingTop: 12, borderTop: '1px solid var(--border)' }}>
                  {a.status !== 'published' && <button className="btn btn-success btn-sm" onClick={(e) => handlePublish(a.id, e)}><FiGlobe /> Publier</button>}
                  <button className="btn btn-secondary btn-sm" onClick={(e) => { e.stopPropagation(); navigate(`/announcements/${a.slug || a.id}/edit`); }}><FiEdit3 /></button>
                  <button className="btn btn-danger btn-sm" onClick={(e) => { e.stopPropagation(); handleDelete(a.id); }}><FiTrash2 /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="card">
          <DataTable 
            columns={[
              { header: 'Image', render: r => r.image_url ? <img src={r.image_url} alt="" style={{ width: 60, height: 45, objectFit: 'cover', borderRadius: 4 }} /> : '-' },
              { header: 'Titre', accessor: 'title' },
              { header: 'Bien', render: r => <>{r.property_title}{r.unit_number ? ` (Unité ${r.unit_number})` : ''}</> },
              { header: 'Statut', render: r => <span className={`badge badge-${r.status === 'published' ? 'success' : 'secondary'}`}>{r.status}</span> },
              { header: 'Vues', render: r => <><FiEye size={14} /> {r.views_count}</> },
              { header: 'Actions', render: r => (
                <div style={{ display: 'flex', gap: 6 }}>
                  {r.status !== 'published' && <button className="btn btn-success btn-sm" onClick={(e) => handlePublish(r.id, e)}><FiGlobe /></button>}
                  <button className="btn btn-secondary btn-sm" onClick={() => navigate(`/announcements/${r.slug || r.id}`)}><FiEye /></button>
                  <button className="btn btn-danger btn-sm" onClick={() => handleDelete(r.id)}><FiTrash2 /></button>
                </div>
              )}
            ]} 
            data={announcements} 
            emptyMessage="Aucune annonce" 
          />
        </div>
      )}

      {/* Pagination */}
      {pagination.total > pagination.limit && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12, marginTop: 24 }}>
          <button className="btn btn-secondary btn-sm" disabled={currentPage === 1} onClick={() => setPagination(p => ({ ...p, offset: p.offset - p.limit }))}><FiChevronLeft /></button>
          <span style={{ fontSize: 14, color: 'var(--text-secondary)' }}>Page {currentPage} / {totalPages}</span>
          <button className="btn btn-secondary btn-sm" disabled={currentPage >= totalPages} onClick={() => setPagination(p => ({ ...p, offset: p.offset + p.limit }))}><FiChevronRight /></button>
        </div>
      )}

      {/* Modal création */}
      <Modal isOpen={showModal} onClose={() => setShowModal(false)} title="Nouvelle annonce" size="lg">
        <form onSubmit={handleCreate}>
          <div className="form-group"><label>Bien *</label>
            <select
              className="form-control"
              value={form.property_id}
              onChange={e => handlePropertyChange(e.target.value)}
              required
            >
              <option value="">Sélectionner un bien</option>
              {properties.map(p => (
                <option key={p.id} value={p.id}>
                  {p.title} ({p.city} — {parseInt(p.price || 0).toLocaleString()} XOF){p.is_multi_unit ? ' 🏢' : ''}
                </option>
              ))}
            </select>
          </div>

          {/* Sélection d'unité si le bien est multi-unités */}
          {selectedProperty?.is_multi_unit && (
            <div className="form-group" style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 8, padding: '12px 16px' }}>
              <label style={{ color: '#1d4ed8', fontWeight: 600 }}>🏢 Unité spécifique (optionnel)</label>
              <p style={{ fontSize: 12, color: '#64748b', margin: '4px 0 8px' }}>Laissez vide pour annoncer l'immeuble entier.</p>
              {loadingUnits ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#64748b', fontSize: 13 }}>
                  <div className="spinner" style={{ width: 14, height: 14, borderWidth: 2 }} />
                  Chargement des unités...
                </div>
              ) : (
                <select
                  className="form-control"
                  value={form.property_unit_id}
                  onChange={e => setForm({ ...form, property_unit_id: e.target.value })}
                >
                  <option value="">Bien complet (immeuble entier)</option>
                  {units.map(u => (
                    <option key={u.id} value={u.id}>
                      {u.unit_number} — {u.unit_type === 'apartment' ? 'Appt' : u.unit_type}{u.surface_area ? ` · ${u.surface_area}m²` : ''} · {parseInt(u.monthly_rent || 0).toLocaleString()} XOF
                    </option>
                  ))}
                </select>
              )}
            </div>
          )}

          <div className="form-group"><label>Titre public *</label><input className="form-control" value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} placeholder="Ex: Villa moderne 4 chambres à Hippodrome" required /></div>
          <div className="form-group"><label>Description</label><textarea className="form-control" rows={4} value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} placeholder="Décrivez le bien pour attirer les clients..." /></div>
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <div className="form-group"><label>Titre SEO</label><input className="form-control" value={form.seo_title} onChange={e => setForm({ ...form, seo_title: e.target.value })} placeholder="70 caractères max" maxLength={70} /></div>
            <div className="form-group"><label>Description SEO</label><input className="form-control" value={form.seo_description} onChange={e => setForm({ ...form, seo_description: e.target.value })} placeholder="160 caractères max" maxLength={160} /></div>
          </div>
          
          <div className="form-group"><label>Visite virtuelle (URL)</label><input className="form-control" value={form.virtual_tour_url} onChange={e => setForm({ ...form, virtual_tour_url: e.target.value })} placeholder="https://..." /></div>
          
          <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: 8, padding: 12, background: '#fffbeb', borderRadius: 8, border: '1px solid #fcd34d' }}>
            <input type="checkbox" id="featured" checked={form.is_featured} onChange={e => setForm({ ...form, is_featured: e.target.checked })} />
            <label htmlFor="featured" style={{ margin: 0, cursor: 'pointer' }}><strong>⭐ Annonce en vedette</strong> — Apparaît en priorité sur la page d'accueil</label>
          </div>
          
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, marginTop: 20 }}>
            <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Annuler</button>
            <button type="submit" className="btn btn-primary">Créer l'annonce</button>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default AnnouncementListPage;